<clarity-ops-visualizer-ui
  [source]="source"
  [authToken]="authToken$ | async"
></clarity-ops-visualizer-ui>
